<template>
	<PortalHeaderNavMobileGeneric
		v-model:is-open="isMobileMenuOpen"
		variant="left"
	>
		<template #header>
			<NuxtLink
				to="/"
				aria-label="Logo"
				@click="trackHeader.handleEventHeaderClick('Logo', '/')"
			>
				<LinearPilarLogo class="h-4 w-auto text-white lg:h-5" />
			</NuxtLink>
		</template>
		<template #content>
			<section
				class="flex flex-col items-start justify-between border-b border-b-primary-light-4 pb-3"
			>
				<h2
					class="px-5 py-[13.5px] text-base font-normal leading-[24px] text-white"
				>
					Compras
				</h2>
				<div class="flex w-full flex-col">
					<template v-for="option in buyOptions" :key="option.label">
						<PortalHeaderNavMobileOptionLink
							v-if="!option.subOptions"
							:option="option"
							class="px-8 py-[13.5px]"
						/>
						<PortalHeaderNavMobileOptionAccordion
							v-if="option.subOptions"
							:option="option"
						/>
					</template>
				</div>
			</section>
			<section
				class="flex flex-col items-start justify-between border-b border-b-primary-light-4 pb-3"
			>
				<h2
					class="px-5 py-[13.5px] text-base font-normal leading-[24px] text-white"
				>
					Vendas
				</h2>
				<div class="flex w-full flex-col">
					<template v-for="option in sellOptions" :key="option.label">
						<PortalHeaderNavMobileOptionLink
							v-if="!option.subOptions"
							:option="option"
							class="px-8 py-[13.5px]"
						/>
					</template>
				</div>
			</section>
			<section class="flex flex-col items-start justify-between pt-1">
				<PortalHeaderNavMobileOptionLink
					:option="aboutPilarOption"
					class="w-full px-8 py-[13.5px]"
					@click="handleClickAboutPilar"
				/>
			</section>
		</template>
		<template #footer>
			<NuxtLink
				v-if="loggedIn"
				to="/perfil"
				@click="navigationStore.closeMenus"
			>
				<PortalHeaderNavProfileOption variant="mobile" bg-variant="primary">
					<template #icon>
						<IconMaterialSymbolsLightChevronRight
							class="ml-auto size-6 text-beige"
						/>
					</template>
				</PortalHeaderNavProfileOption>
			</NuxtLink>
			<LoginModal>
				<Button
					v-if="!loggedIn"
					:variant="null"
					class="h-[50px] w-full min-w-[100px] gap-1 border-none bg-primary-light-4 p-0 text-white"
					@click="trackHeader.handleEventHeaderClick('Entrar')"
				>
					<IconMaterialSymbolsLightPersonOutline
						class="ml-[-10px] size-6 text-beige"
					/>
					<span class="text-sm font-medium leading-[20px]">
						{{ t('login') }}
					</span>
				</Button>
			</LoginModal>
		</template>
	</PortalHeaderNavMobileGeneric>
</template>

<script setup lang="ts">
import LinearPilarLogo from '~icons/pilar/linear-logo';
import IconMaterialSymbolsLightExploreOutline from '~icons/material-symbols-light/explore-outline';
import IconMaterialSymbolsLightChevronRight from '~icons/material-symbols-light/chevron-right';
import { highlightBuyOptions, sellOptions, cities, type HeaderProps } from '.';
import messages from './PortalHeader.locale.json';
import PortalHeaderNavMobileAboutPilarButton from './PortalHeaderNavMobileAboutPilarButton.vue';
import { useEvents } from '~/composables/events/useEvents';
const { trackHeader } = useEvents();
import { useNavigationStore } from '~/store/navigationStore';

defineProps<{ variant: HeaderProps['variant'] }>();

const { t } = useI18n({
	useScope: 'local',
	messages
});

const { loggedIn } = useUserSession();
const navigationStore = useNavigationStore();
const { isMobileMenuOpen } = storeToRefs(navigationStore);

const handleClickAboutPilar = () => {
	trackHeader.handleEventHeaderClick('Sobre a Pilar', '/sobre-a-pilar');
};

const cityOptions = computed(() => {
	return cities.map(city => {
		const url = normalizeString(
			`/venda/imoveis/${city.slug}-${city.state}-${city.country}`,
			['-', '/']
		);

		return {
			label: city.name,
			route: url,
			eventProps: {
				clickedButton: city.name,
				action: 'buy',
				clickRegion: true,
				destinationUrl: url
			}
		};
	});
});

const buyOptions = computed(() => [
	...highlightBuyOptions,
	{
		label: 'Explore por regiões',
		icon: {
			component: IconMaterialSymbolsLightExploreOutline,
			bindings: {
				class: 'text-beige'
			}
		},
		subOptions: cityOptions.value
	}
]);

const aboutPilarOption = {
	label: PortalHeaderNavMobileAboutPilarButton,
	route: '/sobre-a-pilar'
};
</script>
